import { shallowEqual, useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useState, useEffect, useRef } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './Store.scss';
import PopUp from './../../Popup/logoutPopup'


const Store = (props) => {

    const dispatch = useDispatch();

    const { login } = useSelector((state) => state.loginReducer, shallowEqual);
    const { freeplay } = useSelector((state) => state.freeplay, shallowEqual);

    const [displayItem, setDisplayItem] = useState(false);
    const [displayCharater, setDisplayCharater] = useState(false);

    const [displayBuyConfirmation, setDisplayBuyConfirmation] = useState(false);
    const [displayCharaterConfirmation, setDisplayCharaterConfirmation] = useState(false);
    const [displayPopup, setDisplayPopup] = useState(false);

    const [displayDeleteConfirmation, setDisplayDeleteConfirmation] = useState(false);
    const [itemConfirm, setItemConfirm] = useState(null);

    const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;
    function sleep(ms) {return new Promise((resolve) => setTimeout(resolve, ms));}


    const coin = generateImageUrl('images/Images/Coin_Empty.png');
    const balance = generateImageUrl('images/newDesign/FreePlay/balance.png');
    const Exit = generateImageUrl('images/Images/close.png')

    useEffect(() => {
        if(props.character){
            document.getElementById('animal').style.backgroundColor= 'green'
            document.getElementById('buy').style.backgroundColor= '#6d6d6d'
            document.getElementById('item').style.backgroundColor= '#6d6d6d'
            setDisplayCharater(true)
        }
    }, []);

    const openCharater = () => {
        document.getElementById('animal').style.backgroundColor= 'green'
        document.getElementById('buy').style.backgroundColor= '#6d6d6d'
        document.getElementById('item').style.backgroundColor= '#6d6d6d'
        setDisplayCharater(true)
        setDisplayItem(false)
    }

    const openItem = () => {
        document.getElementById('item').style.backgroundColor= 'green'
        document.getElementById('buy').style.backgroundColor= '#6d6d6d'
        document.getElementById('animal').style.backgroundColor= '#6d6d6d'
        setDisplayItem(true)
        setDisplayCharater(false)

    }

    const openBuy = () => {
        document.getElementById('buy').style.backgroundColor= 'green'
        document.getElementById('item').style.backgroundColor= '#6d6d6d'
        document.getElementById('animal').style.backgroundColor= '#6d6d6d'
        setDisplayItem(false)
        setDisplayCharater(false)
    }

    const buyConfirm = (item) => {
        setItemConfirm(item)
        setDisplayBuyConfirmation(true)
    }

    const charaterConfirm = (item) => {
        setItemConfirm(item)
        setDisplayCharaterConfirmation(true)
    }

    const deleteConfirm = (item) => {
        setItemConfirm(item)
        setDisplayDeleteConfirmation(true)
    }
    
    const confirmBuy = () => {
        if (props.coin >= itemConfirm.coin){
            dispatch({ type: `FREEPLAY_SET_${props.level}_COIN`, payload: props.coin - itemConfirm.coin});          
            let bought;
            if(props.boughts.findIndex(item => item.name === itemConfirm.name) !== -1 ){
                let i = 1
                while(true){
                    let check = props.boughts.filter(item => item.name === itemConfirm.name);
                    if(check.findIndex(item => item.id === i) !== -1){
                        ++i;
                    }
                    else{
                        bought = {name: itemConfirm.name, url: itemConfirm.img, position: {x: 0.4, y: 0.4}, coin: itemConfirm.coin, id: i}
                        break;
                    }
                }
            }
            else{
                bought = {name: itemConfirm.name, url: itemConfirm.img, position: {x: 0.4, y: 0.4}, coin: itemConfirm.coin, id: 0}
            }
            props.decorate.items.push(bought);
            dispatch({ type: `FREEPLAY_SET_DECORATE_${props.level}`, payload: props.decorate });
            props.setBoughts(props.decorate.items);
            props.close(false)
            props.setChange(true);
        }
        else{
            // window.alert('No enough coin')
            setDisplayPopup(true)
        }
    }
    
    

    const confirmDelete = () => {
        dispatch({ type: `FREEPLAY_SET_${props.level}_COIN`, payload: props.coin + itemConfirm.coin}); 
        props.decorate.items = props.boughts.filter(item => item !== itemConfirm);   
        dispatch({ type: `FREEPLAY_SET_DECORATE_${props.level}`, payload: props.decorate });    
        props.setBoughts(props.decorate.items);
        setDisplayDeleteConfirmation(false)
        props.setUpdate(!props.update)
    }


    return (
        <div className='storeBody'>
            <div className='storeBG'>
            </div>
            {displayPopup && <PopUp
                content={
                <>
                    <b id="title">
                    Not enough coins
                    <br />
                    </b>
                    <button
                    id="logoutButton2"
                    className="logoutButton"
                    onClick={() => {
                        setDisplayPopup(false)
                    }}
                    >
                    <b id="title">
                        OKAY
                    </b>
                    </button>
                </>
                }
            />}
            <img
                className='close'
                src={Exit}
                onClick={() => {props.close(false) }}
            />
            <h1 className='title'><span>STORE</span></h1>
            <div className='coins'>
                <img src={balance} alt='balance Icon'/>
                {props.coin < 10 && <div className='coin1'>{props.coin}</div>}
                {props.coin >= 10 && props.coin < 100 && <div className='coin10'>{props.coin}</div>}
                {props.coin >= 100 && <div className='coin100'>{props.coin}</div>}
            </div>
            <div className='storeButton'>
                <Container>
                    <Row xs={3}>
                        <Col> 
                            <div className='button' id="animal" onClick={() => {openCharater()}}>
                                <div className='text'>Your Characters</div>
                            </div>                        
                        </Col>
                        <Col> 
                            <div className='button' id="item" onClick={() => {openItem()}}>
                                <div className='text'>Your Scenes and Items</div>
                            </div>                        
                        </Col>
                        <Col> 
                            <div className='button' id="buy" onClick={() => {openBuy()}}>
                                <div className='text'>Buy</div>
                            </div>
                        </Col> 
                    </Row>
                    <br/>
                    {displayCharater && <p className='info'>Click on the character to add it to the scene, or click on the camera to retake your photo.</p>}
                </Container>
            </div>
            {displayCharater && <div className='charaters'>
                <Container>
                    {props.animals.length ?
                        <Row xs={1} md={2} lg={3} >
                            {props.animals.map((animal, index) => (
                                 <Col key={index}>
                                    <div className='charater' onClick={() => {charaterConfirm(animal)}}>
                                            <div className='icon'>
                                                <img className='imgs' src={animal.img}/>
                                                <img className='delete' src={generateImageUrl('images/Module4Images/Reward_Camera.png')} onClick={() => {props.retakePhoto(animal)}}/>
                                            </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                        :
                        <div>
                            <h1>No Items</h1>
                            <h1>Your character will appear here once you completed a conversation type</h1>
                        </div>
                    }
                </Container>
            </div>}
            {displayItem && <div className='itemPage'>
                <div className='bg'>
                    {props.bgs.map((bg, index) => (
                            <div key={index} onClick={() => {
                                props.decorate.background = index;         
                                dispatch({ type: `FREEPLAY_SET_DECORATE_${props.level}`, payload: props.decorate });
                                props.setBgIdx(index);
                                props.setUpdate(!props.update)}}>
                                <img className='icon' src={bg} />
                            </div>

                    ))}
                </div>
                <div className='item'>
                    <Container>
                        <Row xs={3} md={4} lg={5} >
                            {props.boughts.map((bought, index) => (
                                <Col key={index}>
                                    <div className='bought'>
                                        <div className='icon'>
                                            <img className='imgs' src={bought.url.includes("https:") ? bought.url : generateImageUrl(bought.url)} />
                                            <img className='delete' src={Exit} onClick={() => {deleteConfirm(bought)}}/>
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </div>
            </div>}
            {!displayItem && !displayCharater && <div className='buyPage'>
                <Container>
                    <Row xs={3} md={4} lg={5} >
                        {props.buys.map((buy, index) => (
                            <Col key={index}>
                                <div className='buy' onClick={() => {buyConfirm(buy)}}>
                                    <div className='icon'>
                                        <img src={generateImageUrl(buy.img)} />
                                    </div>
                                    <div className='amount'>
                                        <img className='coin' src={coin}/>
                                        <h2 className={buy.coin >= 10 ? 'number10' : 'number'}>{buy.coin}</h2>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </div>}
            {displayBuyConfirmation && <div className='confirmation'>
                <div className='icon'>
                 <img src={generateImageUrl(itemConfirm.img)}/>
                </div>
                <div className='text' >This item costs {itemConfirm.coin} {itemConfirm.coin <= 1 ? "coin" : "coins"}, are you sure you want to buy this?</div>
                <div className='confirmationButton'>
                <Container>
                    <Row xs={2}>
                        <Col> 
                            <div className='button' id="yes" onClick={() => {confirmBuy()}}>
                                <div className='text'>Yes</div>
                            </div>                        
                        </Col>
                        <Col> 
                            <div className='button' id="no" onClick={() => {setDisplayBuyConfirmation(false)}}>
                                <div className='text'>No</div>
                            </div>
                        </Col> 
                    </Row>
                </Container>
            </div>
            </div>}
            {displayCharaterConfirmation && <div className='confirmation'>
                <div className='icon'>
                 <img src={itemConfirm.img}/>
                </div>
                <div className='text' >You can put this on your background. Are you sure you want to do this?</div>
                <div className='confirmationButton'>
                <Container>
                    <Row xs={2}>
                        <Col> 
                            <div className='button' id="yes" onClick={() => {confirmBuy()}}>
                                <div className='text'>Yes</div>
                            </div>                        
                        </Col>
                        <Col> 
                            <div className='button' id="no" onClick={() => {setDisplayCharaterConfirmation(false)}}>
                                <div className='text'>No</div>
                            </div>
                        </Col> 
                    </Row>
                </Container>
            </div>
            </div>}
            {displayDeleteConfirmation && <div className='confirmation'>
                <div className='icon'>
                 <img src={itemConfirm.url.includes("https:") ? itemConfirm.url : generateImageUrl(itemConfirm.url)}/>
                </div>
                <div className='text' >{itemConfirm.coin} {itemConfirm.coin <= 1 ? "coin" : "coins"} will be given back to you. Are you sure you want to delete this?</div>
                <div className='confirmationButton'>
                <Container>
                    <Row xs={2}>
                        <Col> 
                            <div className='button' id="yes" onClick={() => {confirmDelete()}}>
                                <div className='text'>Yes</div>
                            </div>                        
                        </Col>
                        <Col> 
                            <div className='button' id="no" onClick={() => {setDisplayDeleteConfirmation(false)}}>
                                <div className='text'>No</div>
                            </div>
                        </Col> 
                    </Row>
                </Container>
            </div>
            </div>}
        </div>
    );
};
export default Store;